import React, {useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Button
} from '@mui/material';
import axios from 'axios';
import {IoIosCloseCircle} from "react-icons/io";
import Select from 'react-select'; // Using React Select for all dropdowns

const CreateChatGroupPopup = ({open, onClose, users, onChatCreate, userId}) => {
    const [chatName, setChatName] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);

    const departments = [
        {value: null, label: 'ყველა დეპარტამენტი'},
        {value: 1, label: 'მომეტებული ტექნიკური საფრთხის შემცველი ობიექტების ზედამხედველობის სამმართველო'},
        {value: 2, label: 'განსაკუთრებული ობიექტების მშენებლობის ნებართვებისა და ზედამხედველობის სამმართველო'},
        {value: 3, label: 'სამართლებრივი უზრუნველყოფის სამმართველო'},
        {value: 4, label: 'ადმინისტრირებისა და ინფორმაციული უზრუნველყოფის სამმართველო'}
    ];

    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };

    const handleSelectAllUsers = () => {
        const combinedUsers = [...selectedUsers, ...userOptionsForSelectAll];

        const uniqueCombinedUsers = Array.from(new Set(combinedUsers.map(user => user.value)))
            .map(value => combinedUsers.find(user => user.value === value));

        setSelectedUsers(uniqueCombinedUsers);
    };

    const handleUnselectAllUsers = () => {
        setSelectedUsers([]);
    };


    const handleDepartmentChange = selectedOption => {
        setSelectedDepartmentId(selectedOption ? selectedOption.value : null);
    };

    const handleCreateChatGroup = async () => {
        const uniqueSelectedUsers = Array.from(new Set([...selectedUsers.map(user => user.value), userId]));

        const payload = {
            chatName: chatName,
            chatUsersIds: uniqueSelectedUsers,
            caseNumber: ""
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewChatGroup`, payload);
            if (response.data.resultId) {
                const payload = {
                    chatGroupId: parseInt(response.data.resultId),
                    message: "27015*&*&",
                    creatorUserID: userId,
                    creatorUserFullName: `27015*&*&`,
                    seenThisMessageUserIds: uniqueSelectedUsers
                };
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewChatMessage`, payload);
            }

            onClose();
            onChatCreate();
        } catch (error) {
            console.error('Failed to create chat group:', error);
        }
    };

    const userOptions = users
        .filter(user => user.departmentId === selectedDepartmentId || selectedDepartmentId === null)
        .filter(user => user.id !== userId)
        .map(user => ({
            value: user.id,
            label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
            departmentId: user.departmentId
        }));

    const userOptionsForSelectAll = users
        .filter(user => user.id !== userId && (selectedDepartmentId === null || user.departmentId === selectedDepartmentId))
        .map(user => ({
            value: user.id,
            label: `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})`,
            departmentId: user.departmentId
        }));


    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    maxHeight: '80vh',
                    minHeight: '650px',
                },
            }}
        >
            <IoIosCloseCircle className="upload-single-close-icon-text-editor" onClick={onClose}/>
            <DialogTitle>ჯგუფური ჩატის შექმნა</DialogTitle>
            <DialogContent style={{maxHeight: '80vh', overflowY: 'auto'}}>
                <TextField
                    style={{marginBottom: 20}}
                    label="ჩატის სახელი"
                    fullWidth
                    margin="dense"
                    value={chatName}
                    onChange={(e) => setChatName(e.target.value)}
                />
                <Select
                    options={departments}
                    onChange={handleDepartmentChange}
                    placeholder="აირჩიეთ დეპარტამენტი"
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable
                    isSearchable
                />
                <div style={{marginBottom: 20}}>
                </div>
                <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={userOptions}
                    value={selectedUsers}
                    onChange={setSelectedUsers}
                    placeholder="აირჩეთ თანამშრომლები"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    noOptionsMessage={() => "არაფერი მოიძებნა"}
                />
                <div style={{marginBottom: 20}}>
                </div>
                <div>
                    <Button onClick={handleSelectAllUsers} color="primary">ყველას არჩევა</Button>
                    <Button onClick={handleUnselectAllUsers} color="primary">გასუფთავება</Button>
                </div>
            </DialogContent>


            <DialogActions>
                <Button disabled={selectedUsers.length === 0 || !chatName} onClick={handleCreateChatGroup}
                        color="primary">
                    შექმნა
                </Button>
                <Button onClick={onClose} color="secondary">
                    გაუქმება
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateChatGroupPopup;
